import * as React from 'react';

import classNames from 'classnames';

import { Text } from '@components/common';
import { ArrowRightSVG } from '@components/svgs';

type Props = {
  leftSide: React.ReactNode | string;
  rightSide: React.ReactNode | string;
  itemsAlign?: 'center' | 'start';
};

export const DiffRow: React.FC<React.PropsWithChildren<Props>> = ({ leftSide, rightSide, itemsAlign = 'center' }) => (
  <div
    className={classNames('flex w-full py-2.5', {
      'items-center': itemsAlign === 'center',
      'items-start': itemsAlign === 'start'
    })}
  >
    <div className='min-w-0 flex-1'>
      {typeof leftSide === 'string' ? (
        <Text as='span' h='400' className='line-through'>
          {leftSide}
        </Text>
      ) : (
        leftSide
      )}
    </div>
    <div className='mx-2 flex-shrink-0 self-center'>
      <ArrowRightSVG />
    </div>
    <div
      className={classNames('min-w-0 flex-1', {
        'text-right': itemsAlign === 'center'
      })}
    >
      {typeof rightSide === 'string' ? (
        <Text as='span' h='400'>
          {rightSide}
        </Text>
      ) : (
        rightSide
      )}
    </div>
  </div>
);
